import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SEO from './SEO';
import { modulos, listaModulos } from '../data/modulos';
import ModuleDetail from './ModuleDetail';
import './FeatureDetails.css';

const FeatureDetails = () => {
  const { moduloId } = useParams();
  const navigate = useNavigate();

  // Se há um módulo específico na URL, mostra o detalhe
  if (moduloId && modulos[moduloId]) {
    return <ModuleDetail modulo={modulos[moduloId]} />;
  }

  // Caso contrário, mostra a visão geral de todos os módulos
  return (
    <div className="feature-details-page">
      <SEO
        title="Funcionalidades Completas - Veritux ERP"
        description="Conheça todas as funcionalidades do Veritux ERP: Comercial, Compras, Estoque, Financeiro, Caixa, Notas Fiscais, PDV/Delivery e Serviços."
        keywords="funcionalidades ERP, módulos ERP, sistema de gestão, gestão comercial, gestão financeira, controle de estoque"
        url="https://www.veritux.com.br/funcionalidades"
      />
      
      {/* Header */}
      <header className="feature-header">
        <div className="container">
          <Link to="/" className="back-link">
            ← Voltar para a página inicial
          </Link>
          <h1 className="feature-main-title">Funcionalidades Completas</h1>
          <p className="feature-main-subtitle">
            Conheça todos os módulos e funcionalidades do Veritux ERP
          </p>
        </div>
      </header>

      {/* Visão Geral dos Módulos */}
      <section className="modules-overview">
        <div className="container">
          <div className="modules-grid">
            {listaModulos.map((modulo) => (
              <div 
                key={modulo.id} 
                className="module-card"
                onClick={() => navigate(`/funcionalidades/${modulo.id}`)}
              >
                <div className="module-card-header">
                  <div className="module-icon-large">{modulo.icone}</div>
                  <h2 className="module-card-title">{modulo.titulo}</h2>
                </div>
                <p className="module-card-description">{modulo.descricao}</p>
                <div className="module-card-features">
                  <h3 className="module-card-features-title">Principais funcionalidades:</h3>
                  <ul className="module-card-features-list">
                    {modulo.funcionalidades.slice(0, 3).map((func, index) => (
                      <li key={index}>{func.nome}</li>
                    ))}
                    {modulo.funcionalidades.length > 3 && (
                      <li className="more-features">+{modulo.funcionalidades.length - 3} mais</li>
                    )}
                  </ul>
                </div>
                <div className="module-card-footer">
                  <span className="module-card-link">
                    Ver detalhes →
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recursos Principais */}
      <section className="main-features">
        <div className="container">
          <h2 className="section-title">Recursos Principais</h2>
          <div className="resources-grid">
            <div className="resource-item">
              <div className="resource-icon">💳</div>
              <h3 className="resource-title">Geração de Boletos</h3>
              <p className="resource-text">
                Geração de boletos de quase todos os bancos nacionais com qualquer tipo de carteira.
              </p>
            </div>
            <div className="resource-item">
              <div className="resource-icon">💵</div>
              <h3 className="resource-title">Controle de Caixa</h3>
              <p className="resource-text">
                Controle completo de movimentações de caixa com fechamento e relatórios.
              </p>
            </div>
            <div className="resource-item">
              <div className="resource-icon">📋</div>
              <h3 className="resource-title">Contas a Pagar e Receber</h3>
              <p className="resource-text">
                Gestão completa de contas a pagar e receber com controle de vencimentos e fluxo de caixa.
              </p>
            </div>
            <div className="resource-item">
              <div className="resource-icon">📝</div>
              <h3 className="resource-title">Histórico de Cheques</h3>
              <p className="resource-text">
                Controle completo do histórico de cheques emitidos e recebidos.
              </p>
            </div>
            <div className="resource-item">
              <div className="resource-icon">📦</div>
              <h3 className="resource-title">Estoque</h3>
              <p className="resource-text">
                Controle completo de estoque com movimentações, estoque mínimo e curva ABC.
              </p>
            </div>
            <div className="resource-item">
              <div className="resource-icon">📄</div>
              <h3 className="resource-title">Notas Fiscais</h3>
              <p className="resource-text">
                Envio de notas tipo NF-e, NFS-e e NFC-e com integração à Receita Federal.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FeatureDetails;
